module.exports = __webpack_public_path__ + "static/media/home.485238e9.svg";